import type {
  IHttpCall,
  IHttpRequest,
  IHttpResponse,
} from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import {
  TrackConversionRequestDto,
  TrackConversionResponseDto,
} from '../dto/track-conversion';

type TrackConversionOptions = Partial<Omit<IHttpRequest<void>, 'body'>> & {
  httpCall?: IHttpCall;
};

export function trackConversion(
  baseUrl: string,
  payload: TrackConversionRequestDto,
  options?: TrackConversionOptions,
): Promise<IHttpResponse<TrackConversionResponseDto>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const request: IHttpRequest<TrackConversionRequestDto> = {
    url: `${baseUrl}/api/event`,
    method: 'POST',
    body: payload,
    headers,
    schemas: {
      request: TrackConversionRequestDto,
      response: TrackConversionResponseDto,
    },
    ...restOptions,
  };

  return httpCall(request);
}
